__turbopack_context__.v({
  "bottomSheet": "ProductCardAccessories-module__rB14dq__bottomSheet",
  "offerPill": "ProductCardAccessories-module__rB14dq__offerPill",
  "offerPillWrap": "ProductCardAccessories-module__rB14dq__offerPillWrap",
  "root": "ProductCardAccessories-module__rB14dq__root",
});
